// Company expenses — finance records, optionally linked to a matter (case) and
// /or a contract. Backend: /api/v1/web/expenses.

export type ExpenseStatus = 'NEW' | 'PENDING' | 'ACCEPTED' | 'DENIED';

export const EXPENSE_STATUS_VALUES: ExpenseStatus[] = [
  'NEW',
  'PENDING',
  'ACCEPTED',
  'DENIED',
];

// Mirrors the backend `Curreny` enum.
export type Currency = 'USD' | 'UZS';

export const CURRENCY_VALUES: Currency[] = ['USD', 'UZS'];

export const DEFAULT_CURRENCY: Currency = 'USD';

interface NamedRef {
  id: number;
  name?: string | null | undefined;
}

export interface Expense {
  id: number;
  rate: number;
  quantity: number;
  /** Derived server-side: rate × quantity. */
  amount: number;
  currency: Currency;
  nonBillable: boolean;
  status: ExpenseStatus;
  expenseCategoryId?: number | null | undefined;
  expenseCategory?: NamedRef | null | undefined;
  matterId?: number | null | undefined;
  matter?: NamedRef | null | undefined;
  contractId?: number | null | undefined;
  contract?: NamedRef | null | undefined;
  createdById?: number | null | undefined;
  createdBy?: NamedRef | null | undefined;
  createdAt: string;
  updatedAt?: string | undefined;
}

export interface CreateExpenseDto {
  rate: number;
  quantity: number;
  currency?: Currency | undefined;
  expenseCategoryId?: number | undefined;
  matterId?: number | undefined;
  contractId?: number | undefined;
}

export type UpdateExpenseDto = Partial<CreateExpenseDto>;

export interface ExpenseFilters {
  status?: ExpenseStatus | undefined;
  expenseCategoryId?: number | undefined;
  matterId?: number | undefined;
  contractId?: number | undefined;
  limit?: number | undefined;
  page?: number | undefined;
  [key: string]: unknown;
}

export interface ExpenseListResponse {
  results: Expense[];
  meta: {
    offset: number;
    limit: number;
    total: number;
  };
}
